import { queryOptions } from '@tanstack/react-query';

import { getTaskDetail, getTaskList } from './api';

import type { AxiosInstance } from 'axios';
import type { TaskListParams } from '../../constants';

/**
 * Task Query Factory.
 * @description
 * - list: 페이지네이션 없이 전체를 한 번에 조회 (FE에서 탭 필터링).
 *   폴링(3초)은 소비 훅(useTaskList)에서 `refetchInterval`로 제어한다.
 * - 진행 중 task 유무를 트래킹하는 단일 진실 공급원(SSOT)이 곧 이 list 응답이다.
 */
export const taskQueries = {
  all: () => ['tasks'] as const,

  lists: () => [...taskQueries.all(), 'list'] as const,

  list: (instance: AxiosInstance, params?: TaskListParams) =>
    queryOptions({
      queryKey: [...taskQueries.lists(), params ?? {}] as const,
      queryFn: ({ signal }) => getTaskList(instance, params, signal),
    }),

  details: () => [...taskQueries.all(), 'detail'] as const,

  detail: (instance: AxiosInstance, taskId: string) =>
    queryOptions({
      queryKey: [...taskQueries.details(), taskId] as const,
      queryFn: ({ signal }) => getTaskDetail(instance, taskId, signal),
      enabled: Boolean(taskId),
    }),
};
